import { defineStyleConfig } from '@chakra-ui/react';

export const Card = defineStyleConfig({
  baseStyle: {
    container: {
      bg: 'surface.card',
      borderColor: 'border.card',
      borderWidth: '1px',
      borderRadius: 'xl',
      shadow: 'card',
    },
  },
});
